<template>
    <div>
        <v-dialog v-model="sessionDialog" max-width="768">
            <v-card>
                <v-card-title>
                    <span>{{ $t('create_session') }}</span>
                </v-card-title>
                <v-card-text>
                    <v-form ref="webinarSessionForm">
                        <v-row>
                            <v-col cols="12" lg="12">
                                <v-text-field v-model="editedSessionItem.name" :label="$t('name')" required
                                    :rules="nameRules"></v-text-field>
                            </v-col>
                            <v-col cols="12" lg="12">
                                <v-select v-model="editedSessionItem.driver" :items="drivers" :label="$t('driver')"
                                    item-text="title" item-value="driver" required>
                                </v-select>
                            </v-col>
                            <v-col cols="4" lg="4">
                                <v-text-field v-model="editedSessionItem.duration" :label="$t('duration')" required
                                    dense type="number">
                                    {{ $t('duration') }}</v-text-field>
                            </v-col>
                            <v-col cols="8" lg="8">

                                <v-slider v-model="editedSessionItem.duration" required min="0" max="360"
                                    thumb-label="always" dense>

                                </v-slider>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="saveNewSession">
                        {{ $t('save') }}
                    </v-btn>
                    <v-btn color="primary" text @click="close">
                        {{ $t('close') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-card>
            <v-data-table :headers="tableHeaders" :items="roomsList" :loading="loading" class="elevation-1"
                :server-items-length="totalRows" :options.sync="options" disable-sort item-key="id" show-expand
                single-expand>
                <template v-slot:top>
                    <v-toolbar flat>
                        <v-toolbar-title>{{ webinarName }}</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn text icon color="primary" dark class="mb-2" v-bind="attrs" v-on="on"
                                    @click="getRoomsList">
                                    <v-icon large>mdi-refresh</v-icon>
                                </v-btn>
                            </template>
                            <span>
                                {{ $t('refresh') }}
                            </span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn text icon color="primary" dark class="mb-2" v-bind="attrs" v-on="on"
                                    @click="sessionDialog = true" v-show="!hasPermission('webinar_plus_room_add')">
                                    <v-icon large>mdi-plus</v-icon>
                                </v-btn>
                            </template>
                            <span>
                                {{ $t('create_session') }}
                            </span>
                        </v-tooltip>
                    </v-toolbar>
                </template>
                <template v-slot:[`item.driver`]="{ item }">
                    {{ $t(item.driver.toLowerCase()) }}
                </template>
                <template v-slot:[`item.md_code`]="{ item }">
                    {{ item.md_code }}
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn class="ma-2" text icon color="primary" v-bind="attrs" v-on="on"
                            >
                                <v-icon medium @click="joinTo(item.md_code)">mdi-account-star</v-icon>
                            </v-btn>
                        </template>
                        <span>{{ $t('join_as_moderator') }}</span>
                    </v-tooltip>
                </template>
                <template v-slot:[`item.at_code`]="{ item }">
                    {{ item.at_code }}
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn class="ma-2" text icon color="primary" v-bind="attrs" v-on="on">
                                <v-icon medium @click="joinTo(item.at_code)">mdi-account</v-icon>
                            </v-btn>
                        </template>
                        <span>{{ $t('join_as_attendee') }}</span>
                    </v-tooltip>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn class="ma-2" text icon color="primary" v-bind="attrs" v-on="on"
                            :disabled="!hasPermission('webinar_plus_room_update')">
                                <v-icon medium @click="editItem(item)">mdi-pencil</v-icon>
                            </v-btn>
                        </template>
                        <span>{{ $t('edit_session') }}</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn class="ma-2" text icon color="primary" v-bind="attrs" v-on="on" v-show="false">
                                <v-icon medium @click="sendRoomInfoSMS(item)">mdi-message-processing</v-icon>
                            </v-btn>
                        </template>
                        <span>{{ $t('send_room_info_sms') }}</span>
                    </v-tooltip>
                </template>
                <template v-slot:expanded-item="{ headers, item }">

                    <td :colspan="headers.length">
                        <SessionUsers :key="item.id" :roomId="item.id"></SessionUsers>
                    </td>
                </template>
            </v-data-table>
        </v-card>
    </div>
</template>
<script>
import axios from 'axios';
import SessionUsers from './SessionUsers.vue';
import permissions from '../mixins/permissions';
export default {
    name: "WebinarRooms",
    components: { SessionUsers },
    mixins:[permissions],
    props: ["company", "webinarName"],
    data() {
        return {
            tableHeaders: [
                { text: this.$t("name"), value: "name" },
                { text: this.$t("duration"), value: "duration" },
                { text: this.$t("driver"), value: "driver" },
                { text: this.$t("md_code"), value: "md_code" },
                { text: this.$t("at_code"), value: "at_code" },
                { text: this.$t("action"), value: "actions" },
            ],
            roomsList: [],
            sessionDialog: false,
            defaultSessionItem: { id: null, name: '', driver: 'bigblubutton', duration: 30 },
            editedSessionItem: { id: null, name: '', driver: null, duration: 30 },
            nameRules: [v => !!v || this.$t("name_required")],
            drivers: [
                {
                    title: this.$t('bigbluebutton'),
                    driver: 'BBB',
                },
                {
                    title: this.$t('skyroom'),
                    driver: 'SR',
                },
                {
                    title: this.$t('adobeconnect'),
                    driver: 'AD',
                },
            ],
            editedIndex: -1,
            itemPerPage: 10,
            pageNumber: 1,
            plans: [],
            loading: false,
            options: {},
            totalRows: 0,
            startRow: 0,
            endRow: 10,
            frontendUrl:''
        };
    },
    watch: {
        options: {
            handler() {
                this.getRoomsList();
            },
            deep: true,
        }
    },
    methods: {
        getRoomsList() {
            const { page, itemsPerPage } = this.options;

            let _startRow = itemsPerPage * page - itemsPerPage;
            let _endRow = itemsPerPage * page - 1;
            if (_endRow < 0)
                _endRow = this.totalServers;
            const payload = { _startRow: _startRow, _endRow: _endRow };
            this.loading = true;
            if (this.company) {
                axios({
                    url: process.env.VUE_APP_BACKEND_URL + "/api/webinar_plus/companies/" + this.company + "/rooms",
                    method: "GET",
                    headers: {
                        // 'Content-Type': 'multipart/form-data',
                        Authorization: this.$store.get("login/token"),
                    },
                    params: payload
                }).then(response => {
                    console.log("data", response);
                    const data = response.data.response.data;
                    this.roomsList = data;
                    this.totalRows = data.length;
                    this.loading = false;
                });
            }
        },
        joinTo(code) {
            window.open(this.frontendUrl+"/join/" + code, "_blank");
        },
        validateWebinarSessionForm() {
            this.$refs.webinarSessionForm.validate();
        },
        resetValidateWebinarSessionForm() {
            // this.$refs.webinarForm.resetValidation();
        },
        close() {
            this.sessionDialog = false;
            this.$nextTick(() => {
                this.editedSessionItem = Object.assign({}, this.defaultSessionItem);
                this.editedIndex = -1;
                this.resetValidateWebinarSessionForm();
            });
        },
        editItem(item) {
            this.editedIndex = this.roomsList.indexOf(item);
            this.editedSessionItem = Object.assign({}, item);
            this.sessionDialog = true;
        },
        saveNewSession() {
            if (!this.$refs.webinarSessionForm.validate()) {
                this.$toasted.error(this.$t("fill_the_form"), { icon: { name: "alert-circle" } });
            }
            else {

                
                axios({
                    url: process.env.VUE_APP_BACKEND_URL + "/api/webinar_plus/companies/" + this.company + "/rooms",
                    method: this.editedSessionItem.id!=null?"PUT":"POST",
                    headers: {
                        Authorization: this.$store.get("login/token"),
                    },
                    data: this.editedSessionItem,
                }).then(response => {
                    console.log(response.data);
                    this.close();
                    this.getRoomsList();
                    this.$toasted.success(this.$t("webinar_session_added_successfully"));
                }).catch(error => {
                    console.log(error.response);
                    this.$toasted.error(this.$t("webinar_session_error_saving"));
                });
            }
        },
        sendRoomInfoSMS(item) {
            let payload = { room_id: item.id };
            axios({
                url: process.env.VUE_APP_BACKEND_URL + "/api/room_info_sms",
                method: "POST",
                headers: {
                    // 'Content-Type': 'multipart/form-data',
                    Authorization: this.$store.get("login/token"),
                },
                data: payload
            }).then(response => {
                console.log(response.data);
                this.$toasted.success(this.$t("send_room_info_sms_successfully"));
            }).catch(error => {
                console.log(error.response);
                this.$toasted.error(this.$t("send_room_info_sms_error"));
            })
        },
        getFrontendUrl() {
            axios({
                url: process.env.VUE_APP_BACKEND_URL + "/api/config/webinar_plus/frontend_url",
                method: "GET",
                contentType: "",
                headers: {
                    Authorization: this.$store.get("login/token"),
                },
            }).then(response => {
                this.frontendUrl = response.data.value;
            }).catch(error => {
                console.log(error.response);

            });
        }
    },
    mounted() {
        this.getRoomsList();
        this.getFrontendUrl()
    }
}
</script>